import { StaffDetails } from '@libs/models/talents';
import { request } from '../request';

export async function getTalent(id: string): Promise<StaffDetails> {
  const response = await request.get<GetSingleTalentResponse>(`/v2/staff/${id}`);
  return {
    ...response.data,
    fullName: [response.data.firstName, response.data.lastName].filter(Boolean).join(' '),
    status: response.data.staffingStatus,
    qualificationPayRates: response.data.qualificationPayRates.map((q) => ({
      ...q,
      qualification: {
        ...q.qualification,
        name: q.qualification.name,
        abbreviation: q.qualification.abbreviation,
        category: q.qualification.category,
      },
      specialtyPayRates: q.specialtyPayRates.map((s) => ({
        ...s,
        specialty: {
          ...s.specialty,
          name: s.specialty.name,
          category: s.specialty.category,
        },
      })),
    })),
    credentials: response.data.credentials
      ? response.data.credentials.map((c) => ({
          ...c,
          type: c.type,
          name: c.fileName,
          url: c.filePath,
        }))
      : [],
  };
}

type GetSingleTalentResponse = {
  id: string; //'staffmember-01k2sn9pvwm0aw436fqb177fxh';
  imageUrl: string; // 'https://picsum.photos/640/480/?image=553';
  firstName: string; //  'Carey';
  lastName: string; //  'Howell';
  phoneNumber: string; //  '+1 (158) 629-4212';
  email: string; //  'Antonio_Witting60@gmail.com';
  address: {
    firstAddress: string; //  '8823 Jevon Flat';
    city: string; //  'Port Maceyfort';
    state: string; //  'ME';
    zipCode: string; //  '39620';
    secondAddress: string; //  'Suite 185';
  };
  hrInfo: {
    primaryRegion: {
      city: string; //  'Port Cole';
      state: string; //  'ID';
    };
    secondaryRegions: [
      {
        city: string; //  'New Johannberg';
        state: string; //  'IN';
      },
    ];
  };
  jobTitle: string; //  'Central Interactions Assistant';
  location: {
    id: string; //  'location-01k2sn9pvwek4wvmn3hrh0dgkp';
    name: string; //  'Braun - Witting Hospital';
  };
  qualificationPayRates: [
    {
      qualification: {
        id: string; //  'nursequalification-01k2sn9pvw2w8nm33jtdc5hj7j';
        name: string; //  'Name';
        abbreviation: string; //  'Abbreviation';
        category: string; //  'Category';
      };
      rateType: 'Hourly' | 'Monthly' | 'Yearly';
      rate: number;
      specialtyPayRates: [
        {
          specialty: {
            id: string; //  'speciality-01k2sn9pvx98dhb625sessak61';
            name: string; //  'Name';
            category: string; //  'Category';
          };
          rate: number;
        },
      ];
    },
  ];
  employmentType:
    | 'Contract'
    | 'SalariedPartTime'
    | 'SalariedFullTime'
    | 'HourlyPartTime'
    | 'HourlyFullTime'
    | 'PerDiemOrPRN';
  availableForTravelDistance: number;
  workShifts: [
    {
      dayOfWeek: 'Sunday' | 'Monday' | 'Tuesday' | 'Wednesday' | 'Thursday' | 'Friday' | 'Saturday';
      startTime: string; //  '08:00:00';
      duration: string; //  '08:00:00';
    },
  ];
  staffingStatus: 'Active' | 'Deactivated';
  lastWorkedTime: string; //  '2025-08-16T14:42:19.6453854Z';
  contractType: 'W2' | 'TenNinetyNine';
  credentials: {
    type: 'License' | 'Certification' | 'BackgroundCheck' | 'HealthRecord' | 'Assessment' | 'EDocument';
    fileName: string; //  'File Name.pdf'; - any human-readable name (not the physical file name)
    filePath: string; //  'https://example.com/file.pdf';
  }[];
};
